import axios from "axios";
import {
    URLAPI,
    CATEGORY_PATH,
    CATEGORY_CREATE_PATH,
    CATEGORY_UPDATE_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_category: {
        data: [],
        status: 0,
        message: {},
    },
    _create_category: {
        data: {},
        status: 0,
        message: {},
    },
    _update_category: {
        data: {},
        status: 0,
        message: {},
    },
}

const GET_ALL_CATEGORY_SUCCESS = "GET_ALL_CATEGORY_SUCCESS";
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";

export const category_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_CATEGORY_SUCCESS:
            return {
                ...state,
                _get_all_category: action.payload,
            };
        case CREATE_CATEGORY_SUCCESS:
            return {
                ...state,
                _create_category: action.payload,
            };
        case UPDATE_CATEGORY_SUCCESS:
            return {
                ...state,
                _update_category: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}

export const get_all_category = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${CATEGORY_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_CATEGORY_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_CATEGORY_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_CATEGORY_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Ocurrió un error",
                },
            });
        }
    }
}

export const create_category = (token, data) => async (dispatch) => {
    try {
        console.log(data);

        const response = await axios.post(`${URLAPI}${CATEGORY_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: CREATE_CATEGORY_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_CATEGORY_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_CATEGORY_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al crear",
                },
            });
        }
    }
}

export const update_category = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${CATEGORY_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: UPDATE_CATEGORY_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_CATEGORY_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_CATEGORY_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const clear_status_category = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}
